import { ErrorResponseErrorItemCodeAccountUserRequest } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeAccountUserRequest, string> = {
  'account_user_request:already_verified': 'Kontot har redan verifierats.',
  'account_user_request:not_found': 'Ogiltig länk.',
};
